module.exports = __webpack_public_path__ + "static/first_user_image3-842b3871c7ffd98c4c4f4ae0b3d5d20c.jpg";